import React, { useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { apiPost } from "../../utils/api";
import { useHistory, Link } from "react-router-dom";

const articleEmpty = {
  authors: "",
  title: "",
  category: "",
  dissemination_vehicle: "",
  access_link: "",
  year: "",
};

const ArticleCreate = () => {
  const history = useHistory();

  const [state, setState] = useState(articleEmpty);

  const [snack, setSnack] = useState({
    open: false,
    message: "Default message",
    severity: "success",
  });

  const showSnack = (message, severity) => {
    setSnack({
      ...snack,
      open: true,
      message: message,
      severity: severity,
    });
  };

  const handleSnackClose = (e) => {
    setSnack({ ...snack, open: false });
  };

  const handleChange = (e) => {
    const target = e.target;
    const name = target.name;

    setState((previousState) => {
      return { ...previousState, [name]: target.value };
    });
  };

  async function criaArtigo(data) {
    const payload = apiPost("/article", data);

    return await payload;
  }

  async function toLogin() {
    history.push("/login");
  }

  const submitHandler = (e) => {
    e.preventDefault();

    if (state.title.trim().length === 0) {
      showSnack("O título deve ser preenchido!", "warning");
      return;
    } else if (state.authors.trim().length === 0) {
      showSnack("O nome do(s) autor(es) deve ser preenchido!", "warning");
      return;
    } else if (state.year.trim().length === 0) {
      showSnack("O ano deve ser preenchido!", "warning");
      return;
    }

    criaArtigo(state).then(
      (payload) => {
        setState(articleEmpty);
        showSnack("Artigo cadastrado!", "success");
      },
      (error) => {
        let message = "Erro ao cadastrar o artigo!";

        if (error.status === 401) {
          message = "Sem autorização.";
          toLogin();
        }

        showSnack(message, "error");
      }
    );
  };

  return (
    <>
      <section id="management" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Cadastrar novo artigo</h2>
        </div>
      </section>

      <div className="row mx-5 justify-content-center">
        <div className="col-md-5">
          <form onSubmit={submitHandler}>
            <div>
              <label>Autores(as)</label>
              <input
                type="text"
                name="authors"
                value={state.authors}
                onChange={handleChange}
              />
            </div>
            <div>
              <label>Título</label>
              <input
                type="text"
                name="title"
                value={state.title}
                onChange={handleChange}
              />
            </div>
            <div>
              <select
                name="category"
                onChange={handleChange}
                value={state.category}
              >
                <option value="">Selecione uma categoria:</option>
                <option value="Educação Profissional e Institutos Federais">
                  Educação Profissional e Institutos Federais
                </option>
                <option value="Educação Profissional e Novos Caminhos EPT">
                  Educação Profissional e Novos Caminhos EPT
                </option>
                <option value="As Reformas da Educação Profissional e Tecnológica">
                  As Reformas da Educação Profissional e Tecnológica
                </option>
                <option value="Reforma do Ensino Médio e Educação Profissional">
                  Reforma do Ensino Médio e Educação Profissional
                </option>
                <option value="Reformas de Educação Profissional e BNCC">
                  Reformas de Educação Profissional e BNCC
                </option>
              </select>
            </div>
            <div>
              <label>Ano</label>
              <input
                type="text"
                pattern="[0-9]*"
                name="year"
                onChange={(e) =>
                  e.target.validity.valid ? handleChange(e) : state.year
                }
                value={state.year}
              />
            </div>
            <div>
              <label>Nome do veículo</label>
              <input
                type="text"
                name="dissemination_vehicle"
                onChange={handleChange}
                value={state.dissemination_vehicle}
              />
            </div>
            <div>
              <label>Link de acesso</label>
              <input
                type="text"
                name="access_link"
                onChange={handleChange}
                value={state.access_link}
              />
            </div>
            <div>
              <input type="submit" value="Cadastrar artigo" />
            </div>
          </form>
          <Snackbar
            open={snack.open}
            autoHideDuration={6000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity={snack.severity}
              sx={{ width: "100%" }}
            >
              {snack.message}
            </Alert>
          </Snackbar>
          <div>
            <Link className="btn btn-secondary" to="/management/articles/admin">
              Voltar
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ArticleCreate;
